// File Metadata:
// Filename: roles.js
// Version: 1.00
// Created: 2022-09-28 22:12:24
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

export const ROLES = {
	Medewerker: 'Medewerker',
	Voorman: 'Voorman',
	Manager: 'Manager',
	Coordinator: 'Coordinator',
	Admin: 'Admin'
}
